export const Rights = [
    "WEB_MODULE_WORKTIME_WRITE"
]
